<template>
  <section>
    <div v-if="applicantsByVacancyId.length">
      <h4 class="w-full mt-4 md:mt-12 p-3">Bewerber</h4>
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Zuletzt Kontaktiert</th>
            <th>Wohnort</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="applicant in applicantsByVacancyId" :key="applicant.id">
            <td>{{ getFullName(applicant) }}</td>
            <td>
              {{
                applicant.latestHistoryAction
                  ? formatDate(applicant.latestHistoryAction.updatedAt)
                  : "noch nicht kontaktiert"
              }}
            </td>
            <td>
              {{ getPlace(applicant) }}
            </td>
            <td>
              <router-link
                :to="{ name: 'applicant.edit', params: { id: applicant.id } }"
                ><i class="fal fa-arrow-right"></i
              ></router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <h4 v-else class="w-full mt-4 p-3">Noch keine Bewerber</h4>
  </section>
</template>

<script>
import gql from "graphql-tag";

export default {
  props: ["vacancyID"],
  data() {
    return {
      applicantsByVacancyId: []
    };
  },
  apollo: {
    applicantsByVacancyId: {
      query: gql`
        query ApplicantsByVacancyId($id: ID!) {
          applicantsByVacancyId(id: $id) {
            id
            firstName
            lastName
            title
            latestHistoryAction {
              id
              updatedAt
            }
            contactData {
              address {
                zip
                city
              }
            }
          }
        }
      `,
      fetchPolicy: "network-only",
      variables() {
        return { id: this.vacancyID };
      }
    }
  },
  methods: {
    getFullName: applicant => {
      let result = `${applicant.firstName} ${applicant.lastName}`;
      if (applicant.title) {
        result = `${applicant.title} ${result}`;
      }
      return result;
    },
    formatDate: date => {
      let temp = new Date(date);
      return temp.toLocaleDateString(undefined, {
        year: "numeric",
        day: "2-digit",
        month: "2-digit"
      });
    },
    getPlace: applicant => {
      if (
        applicant.contactData &&
        applicant.contactData.address &&
        applicant.contactData.address.zip &&
        applicant.contactData.address.city
      ) {
        return `${applicant.contactData.address.zip} ${applicant.contactData.address.city}`;
      }
      return "Keine Adresse angegeben";
    }
  }
};
</script>
<style scoped>
td {
  padding: 1rem;
  padding-bottom: 0;
  opacity: 0.8;
}
tr + tr {
  border-top: 1px solid lightgray;
}
th {
  padding: 1rem;
  padding-bottom: 0;
  font-size: 1.125rem;
  font-weight: 400;
}
h4 {
  margin-left: 0.5rem;
}
table {
  border-collapse: collapse;
  width: 100%;
}
</style>
